<p-table
  [scrollable]="true"
  [size]="'small'"
  [value]="plugins()"
  scrollHeight="flex"
  stripedRows>
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="nameFr">{{ 'product.name-fr' | translate }}
        <p-sortIcon field="nameFr"/>
      </th>
      <th pResizableColumn pSortableColumn="nameNl">{{ 'product.name-nl' | translate }}
        <p-sortIcon field="nameNl"/>
      </th>
      <th pResizableColumn pSortableColumn="nameEn">{{ 'product.name-en' | translate }}
        <p-sortIcon field="nameEn"/>
      </th>
      <th pResizableColumn pSortableColumn="nameNl">{{ 'product.guid' | translate }}
        <p-sortIcon field="guid"/>
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-plugin>
    <tr (click)="onRowSelect(plugin)" class="cursor-pointer hover:bg-gray-50">
      <td>{{ plugin.nameFr }}</td>
      <td>{{ plugin.nameNl }}</td>
      <td>{{ plugin.nameEn }}</td>
      <td>{{ plugin.guid }}</td>
      <td class="flex justify-end">
        <elcia-button (onClick)="delete($event, plugin)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
</p-table>
